(function () {
  const builders = document.querySelectorAll("[data-subscription-builder]");

  const brewGrinds = {
    espresso: "Espresso",
    filter: "Filter",
    cafetiere: "Cafetiere",
    moka: "Moka",
  };

  const tasteLabels = {
    classic: "classic comfort",
    bright: "two seasonal single origins",
    decaf: "decaf",
    surprise: "the roastery's seasonal picks",
  };

  const cupPlans = {
    solo: {
      cupsPerDay: "1 cup a day",
      cupsPerMonth: "around 30 cups a month",
      monthly: { bag: "500g · 2 × 250g", cups: "about 30 cups" },
      fortnightly: { bag: "500g · 2 × 250g", cups: "about 30 cups every two weeks" },
    },
    regular: {
      cupsPerDay: "2 cups a day",
      cupsPerMonth: "around 55-60 cups a month",
      monthly: { bag: "1kg", cups: "about 55-60 cups" },
      fortnightly: { bag: "500g · 2 × 250g", cups: "about 30 cups every two weeks" },
    },
    household: {
      cupsPerDay: "3-4 cups a day",
      cupsPerMonth: "around 90-120 cups a month",
      monthly: { bag: "2kg", cups: "about 110-120 cups" },
      fortnightly: { bag: "1kg", cups: "about 55-60 cups every two weeks" },
    },
    office: {
      cupsPerDay: "5+ cups a day",
      cupsPerMonth: "more than 120 cups a month",
      monthly: { bag: "2kg", cups: "about 110-120 cups" },
      fortnightly: { bag: "2kg", cups: "about 110-120 cups every two weeks" },
    },
  };

  function getChecked(builder, namePrefix) {
    return builder.querySelector(`input[name^="${namePrefix}"]:checked`)?.value || "";
  }

  function normalizeText(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[\s_-]+/g, " ")
      .trim();
  }

  function buildSubscriptionUrl(baseUrl, track, size, frequency, grind, taste) {
    const url = new URL(baseUrl, window.location.origin);

    url.searchParams.set("track", track);
    url.searchParams.set("size", size);
    url.searchParams.set("frequency", frequency);
    url.searchParams.set("grind", normalizeText(grind).replace(/\s+/g, "-"));
    url.searchParams.set("taste", taste);

    return url.pathname + url.search + url.hash;
  }

  function buildMailto(baseUrl, model, brew, taste, amount, frequency, bag, rhythm, grind) {
    if (!baseUrl.startsWith("mailto:")) return baseUrl;

    const separator = baseUrl.includes("?") ? "&" : "?";
    const body = [
      `Recommended model: ${model}`,
      `Brew method: ${brew}`,
      `Taste: ${taste}`,
      `Amount: ${amount}`,
      `Frequency: ${frequency}`,
      `Suggested bag: ${bag}`,
      `Suggested rhythm: ${rhythm}`,
      `Suggested grind: ${grind}`,
    ].join("\n");

    return `${baseUrl}${separator}body=${encodeURIComponent(body)}`;
  }

  function updateBuilder(builder) {
    const brew = getChecked(builder, "brew");
    const taste = getChecked(builder, "taste");
    const amount = getChecked(builder, "amount");
    const frequency = getChecked(builder, "frequency") || "monthly";
    const cupPlan = cupPlans[amount] || cupPlans.solo;
    const isDiscovery = taste === "bright" || taste === "surprise";
    const plan = isDiscovery
      ? { bag: "500g · 2 × 250g", cups: "about 30 cups each month" }
      : cupPlan[frequency] || cupPlan.monthly;
    const grind = brewGrinds[brew] || "Whole bean";
    const recommendedFrequency = isDiscovery ? "monthly" : frequency;
    const rhythm = recommendedFrequency === "fortnightly" ? "Every two weeks" : "Monthly";
    const track = taste === "decaf" ? "decaf" : isDiscovery ? "discovery" : "everyday";
    const model = track === "decaf" ? "Tempo Decaf" : track === "discovery" ? "Tempo Discovery" : "Tempo Everyday";
    const eyebrow = "Recommended";
    const copy =
      track === "decaf"
        ? `For ${cupPlan.cupsPerDay}, we would start with ${plan.bag} ${rhythm.toLowerCase()}. That gives you ${plan.cups}, with decaf roasted fresh and delivered with shipping included.`
        : track === "discovery"
          ? `Two different 250g single origins arrive each month, chosen from the coffees we are most excited about. Irish delivery is included.`
        : `For ${cupPlan.cupsPerDay}, we would start with ${plan.bag} ${rhythm.toLowerCase()}. That gives you ${plan.cups}, tuned toward ${tasteLabels[taste] || "your taste"}.`;
    const cta = "Build this subscription";
    const url = builder.dataset.subscriptionUrl || builder.dataset.shopUrl || "/products/rhythm";
    const finalUrl = url.startsWith("mailto:")
      ? buildMailto(url, model, brew, taste, amount, frequency, plan.bag, rhythm, grind)
      : buildSubscriptionUrl(url, track, plan.bag, recommendedFrequency, grind, taste);

    builder.querySelector("[data-quiz-eyebrow]").textContent = eyebrow;
    builder.querySelector("[data-quiz-title]").textContent = model;
    builder.querySelector("[data-quiz-copy]").textContent = copy;
    builder.querySelector("[data-quiz-title-inline]").textContent = model;
    builder.querySelector("[data-quiz-copy-inline]").textContent = copy;
    builder.querySelector("[data-quiz-bag]").textContent = plan.bag;
    builder.querySelector("[data-quiz-rhythm]").textContent = rhythm;
    builder.querySelector("[data-quiz-grind]").textContent = `${grind} or whole bean`;

    const link = builder.querySelector("[data-quiz-cta]");
    link.href = finalUrl;
    link.childNodes[0].nodeValue = `${cta} `;
  }

  function preselectProductForm() {
    const params = new URLSearchParams(window.location.search);
    const size = normalizeText(params.get("size"));
    const track = normalizeText(params.get("track"));
    const grind = normalizeText(params.get("grind"));
    const frequency = normalizeText(params.get("frequency"));

    if (!size && !grind && !frequency && !track) return;

    if (track) {
      const trackInput = Array.from(document.querySelectorAll('[data-product-option-name="tempo"] input')).find((input) =>
        normalizeText(input.value).includes(track)
      );
      if (trackInput) {
        trackInput.checked = true;
        trackInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    const sizeInput = Array.from(document.querySelectorAll('[data-product-option-name="size"] input')).find((input) =>
      normalizeText(input.value).includes(size.replace(/-/g, " "))
    );
    if (sizeInput && size) {
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (grind) {
      const grindInput = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="properties[Grind]"]')).find((input) =>
        normalizeText(input.value).includes(grind.replace(/-/g, " "))
      );

      if (grindInput) {
        grindInput.checked = true;
        grindInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    const variantSelect = document.querySelector('form[action*="/cart/add"] select[name="id"]');

    if (variantSelect && (size || grind)) {
      const options = Array.from(variantSelect.options);
      const match = options.find((option) => {
        const label = normalizeText(option.textContent);
        const sizeMatch = !size || label.includes(size);
        const grindMatch = !grind || label.includes(grind.replace(/-/g, " "));

        return !option.disabled && sizeMatch && grindMatch;
      });

      if (match) {
        variantSelect.value = match.value;
        variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    if (frequency) {
      const sellingPlans = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="selling_plan"]'));
      const frequencyTerms =
        frequency === "fortnightly" || frequency === "every two weeks"
          ? ["fortnight", "2 week", "two week", "every 2"]
          : ["month", "4 week", "monthly"];
      const match = sellingPlans.find((input) => {
        const label = normalizeText(input.closest("label")?.textContent);

        return frequencyTerms.some((term) => label.includes(term));
      });

      if (match) {
        match.checked = true;
        match.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  function updateStep(builder, activeIndex) {
    const steps = Array.from(builder.querySelectorAll("[data-quiz-step]"));
    const backButton = builder.querySelector("[data-quiz-back]");
    const nextButton = builder.querySelector("[data-quiz-next]");
    const progressBar = builder.querySelector("[data-quiz-progress-bar]");
    const progressText = builder.querySelector("[data-quiz-progress-text]");
    const finalIndex = steps.length - 1;

    steps.forEach((step, index) => {
      const isActive = index === activeIndex;
      step.hidden = !isActive;
      step.classList.toggle("is-active", isActive);
    });

    backButton.disabled = activeIndex === 0;
    nextButton.childNodes[0].nodeValue = activeIndex === finalIndex ? "Start again " : "Next ";
    progressBar.style.transform = `scaleX(${(activeIndex + 1) / steps.length})`;
    progressText.textContent = `Step ${activeIndex + 1} of ${steps.length}`;
    builder.querySelector(".quiz-shell")?.classList.toggle("is-result-visible", activeIndex === finalIndex);
    const resultPanel = builder.querySelector(".quiz-result");
    if (resultPanel) resultPanel.hidden = activeIndex !== finalIndex;
    builder.dataset.quizStep = String(activeIndex);
  }

  builders.forEach((builder) => {
    builder.addEventListener("change", () => updateBuilder(builder));
    builder.querySelector("[data-quiz-next]")?.addEventListener("click", () => {
      const steps = builder.querySelectorAll("[data-quiz-step]");
      const activeIndex = Number(builder.dataset.quizStep || 0);
      const nextIndex = activeIndex >= steps.length - 1 ? 0 : activeIndex + 1;
      updateStep(builder, nextIndex);
    });
    builder.querySelector("[data-quiz-back]")?.addEventListener("click", () => {
      const activeIndex = Number(builder.dataset.quizStep || 0);
      updateStep(builder, Math.max(0, activeIndex - 1));
    });
    updateBuilder(builder);
    updateStep(builder, 0);
  });

  document.querySelectorAll("[data-tempo-picker]").forEach((picker) => {
    const updatePicker = (mode) => {
      const isPrepaid = mode === "prepaid";
      picker.dataset.tempoMode = mode;

      picker.querySelectorAll("[data-tempo-mode-button]").forEach((button) => {
        button.setAttribute("aria-pressed", String(button.dataset.tempoModeButton === mode));
      });

      picker.querySelectorAll("[data-tempo-price]").forEach((price) => {
        price.textContent = isPrepaid ? price.dataset.prepaidPrice : price.dataset.flexiblePrice;
      });

      picker.querySelectorAll("[data-tempo-link]").forEach((link) => {
        link.href = isPrepaid ? link.dataset.prepaidUrl : link.dataset.flexibleUrl;
      });

      const flexibleAssurance = picker.querySelector("[data-tempo-assurance-flexible]");
      const prepaidAssurance = picker.querySelector("[data-tempo-assurance-prepaid]");
      if (flexibleAssurance) flexibleAssurance.hidden = isPrepaid;
      if (prepaidAssurance) prepaidAssurance.hidden = !isPrepaid;
    };

    picker.querySelectorAll("[data-tempo-mode-button]").forEach((button) => {
      button.addEventListener("click", () => updatePicker(button.dataset.tempoModeButton));
    });

    updatePicker(picker.dataset.tempoMode || "flexible");
  });

  preselectProductForm();
})();
